"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const spinnnerStyles = {
  container: {
    display: 'flex',
    height: '100vh',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    width: '25%',
    minWidth: 300,
    height: '25%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    flexDirection: 'column'
  }
};
const Spinner = _ref => {
  let classes = _ref.classes,
    title = _ref.title,
    subtitle = _ref.subtitle,
    style = _ref.style;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container,
    style: style
  }, /*#__PURE__*/_react.default.createElement(_Paper.default, {
    className: classes.paper
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h4"
  }, title), subtitle ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h5"
  }, subtitle) : null, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    size: "3rem",
    className: classes.spinner
  })));
};
var _default = exports.default = (0, _withStyles.default)(spinnnerStyles)(Spinner);